
export const isDev = () => {
	return process.isDev || false;
}

export function logEvent(message, data) {
	if (!isDev()) {
		return;
	}

	if (console && console.log) {
		console.log.apply(null, arguments);
	}
}

export function logWarning() {
	if (console && console.warn) {
		console.warn.apply(null, arguments);
	}
}

export function throwError(message) {
	if (isDev()) {
		throw new Error(message);
	} else {
		logWarning(message);
	}

}

export function logDispatch(payload) {
	if (window.logDispatch) {
		logEvent('Dispatcher:', payload);
	}
}

if (isDev()) {
	window.logDispatch = false;
}
